import React, {Component} from 'react';
// import * as d3 from 'd3';
import D3Graph from '../container/d3_graph.js'

export default class GraphContainer extends Component{

  componentDidMount(){
    this.refreshHandler = this.refreshHandler.bind(this);
    this.chart = new D3Graph(this.refs.chart, this.props.onRevUpdateClick, this.props.fetchNode, this.refreshHandler);
  }

  componentDidUpdate(prevProps) {
    this.chart.update(this.props.data, prevProps.entity, this.props.entity)
  }

  render(){
    return (<div ref="chart"></div>)
  }

  refreshHandler() {
    this.forceUpdate();
  }

}
